import { render } from "./ModalTitle.vue?vue&type=template&id=017638f0"
import script from "./ModalTitle.vue?vue&type=script&lang=js"
export * from "./ModalTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Modals/ModalTitle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "017638f0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('017638f0', __exports__)) {
    api.reload('017638f0', __exports__)
  }
  
  module.hot.accept("./ModalTitle.vue?vue&type=template&id=017638f0", () => {
    api.rerender('017638f0', render)
  })

}


export default __exports__